import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Route } from 'react-router-dom';

import './index.css';
import App from 'components/App';
import RTL from 'components/RTL';
import ThemeProvider from 'components/ThemeProvider';
import registerServiceWorker from './registerServiceWorker';
import store from './store';

ReactDOM.render(
  <Provider store={ store }>
    <RTL>
      <ThemeProvider>
        <Router>
          <Route path="/" component={ App } />
        </Router>
      </ThemeProvider>
    </RTL>
  </Provider>,
  document.getElementById('root')
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js